import { createPermission } from "@backstage/plugin-permission-common";

/**
 * Permission to access the circles plugin
 */
export const circlesAccessPermission = createPermission({
  name: "circles.access",
  attributes: { action: "read" },
});
